




































































import moment from 'moment';
import { Vue, Prop, Component } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import DateFormat from '@/shared/utils/date-format';
import BillingService from '@/domain/billing/service/billing.service';
import BillingInvoiceUrl from '@/domain/billing/entity/billing-invoice-url.entity';
import BillingDetailed from '@/domain/billing/entity/billing-detailed.entity';

@Component({
  filters: {
    dayMonthYear(date: string): string {
      if (date === undefined || date === '' || date === ' ' || date === null) return '—';
      return DateFormat.timestampToLocal(moment(date).format('YYYY-MM-DD'));
    },
  },
})
export default class BillingInfoV2Header extends Vue {
  @Prop({
    required: true,
  })
  billing!: BillingDetailed;

  @Prop({
    required: false,
    default: '',
  })
  businessUnitId!: string;

  get competence(): string {
    return DateFormat.fullMonthAndYear(this.billing.competence);
  }

  getInvoiceUrl(): void {
    BillingService.getInvoiceUrl(this.businessUnitId, this.billing.invoiceId)
      .then((response: BillingInvoiceUrl) => {
        const win = window.open(response.url, '_blank');
        win!!.focus();
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }
}
